import ko from "knockout";
import $ from "jquery";
import { registerKnockoutBinding } from "flow/knockout/register";

registerKnockoutBinding("autoScrollWhenSelected", {
    update(element, valueAccessor) {
        ko.unwrap(valueAccessor());

        if (valueAccessor()()) {
            setTimeout(() => {
                const container = $(element).parent();
                const scrollTo = $(element);

                container.scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop());
            }, 100);
        }
    }
});
